<template>
  <v-timeline dense clipped>
    <v-timeline-item
      large
      v-for="item in items"
      :key="item.id"
      :color="currencyColorMap.get(item.requested.code)"
      :icon="$helpers.getCurrencyIcon(item.requested.code)"
    >
      <v-list dense two-line>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="body-2">
              <span
                v-html="
                  $t('hr.travel.imprest_message', [
                    `${item.employee.firstName} ${item.employee.lastName}`,
                    $helpers.formattedDateTime(item.timestamp),
                    $helpers.getConvertCurrency(item.requested)
                  ])
                "
              />
            </v-list-item-title>
            <v-list-item-subtitle>
              <request-status-label class="mx-0 subtitle-2" :status="item.requestStatus" />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
  export default {
    name: "TravelImprestsTimeline",
    components: {
      RequestStatusLabel: () => import("@/components/global/request-status-label")
    },
    props: {
      items: Array,
      employee: Object
    },
    data: vm => ({
      currencyColorMap: new Map([
        ["TRY", "pink"],
        ["USD", "green"],
        ["EUR", "orange"]
      ])
    })
  };
</script>

<style></style>
